import styled from 'styled-components';

export const PasswordChangedPageStyle = {
  Container: styled.div``,
  Title: styled.h3``,
  Text: styled.p``,
};
